import { useEffect, useState } from "react"
import * as React from "react";
import Cookies from 'universal-cookie';
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import './Service.css'
import github_logo from '../../images/github-logo.svg'
import { Link } from "react-router-dom";
import komodor_logo from '../../images/komodor_logo.webp'
import Markdown from 'markdown-to-jsx';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip from '@mui/material/Tooltip';
import Modal from "../Modal/Modal";
import datadog_icon from '../../images/DDOG.svg'
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import { DataGrid,GridToolbarQuickFilter } from '@mui/x-data-grid';
import KeyIcon from '@mui/icons-material/Key';
import Moment from 'moment'
import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';
import BackendSecrets from "../BackendSecrets/BackendSecrets";
import valid from "../../functions/functions";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import functions  from "../../functions/functions";
const cookies = new Cookies();


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography component={'span'} variant={'body2'}>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };
  
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
}


export default function Service() {

  const [deployments,set_deployments]=useState()
  const [all_deployments,set_all_deployments]=useState()  
  const [block,set_block] = useState()
  const [value, setValue] = React.useState(0);
  const [inputValue, setInputValue] = React.useState('');
  const[service,set_service]=useState({service_name:""})
  const theme = useTheme();
  const [env, setEnv] = useState();
  const[readme,set_readme] = useState()
  const [open_lock_dialog, set_open_lock_dialog] = useState(false);
  const[open_unlock_dialog,set_open_unlock_dialog] = useState(false)
  const [reason,set_reason]=useState("")
  const[secrets,set_secrets] = useState({})
  const [options,set_options] = useState([])
  const [open_edit_modal,set_open_edit_modal] = useState(false)
  const [open_backend_edit_modal,set_open_backend_edit_modal] = useState(false)
  const [secret_key,set_secret_key] = useState("")
  const[open_create_new_service_secret,set_open_create_new_service_secret] = useState(false)
  
  const [secret_value,set_secret_value] = useState("")
  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: 'action',
        operatorValue: 'contains',
        value: ""
      },
    ],
  });
  const handleClickOpen = () => {
    set_open_lock_dialog(true);
  };
  const handleClickOpen_unlock = () => {
    set_open_unlock_dialog(true);
  };

  const handle_close_modal = () => {
    set_open_lock_dialog(false);
    set_open_unlock_dialog(false);
    set_reason("")
    set_open_edit_modal(false);
    set_open_backend_edit_modal(false);
    set_open_create_new_service_secret(false)
  };

  const icon_map = [
    {icon : github_logo , link: `https://github.com/Workiz/${service.repository}`,description: "Github"},
    {icon : komodor_logo , link : `https://app.komodor.com/services/workiz.wstgcluster-${env}.${service.service_name}`,description: "komodor "},
    {icon: datadog_icon , link : `https://us5.datadoghq.com/apm/services/${service.service_name}`,description: "Datadog "}
  ]

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    useEffect( () => {

        const queryParams = new URLSearchParams(window.location.search)
        const service_name = queryParams.get("service")
        if(service_name == 'backend'){
          set_options(['app','rc', 'staging'])
          setEnv('app')
          set_secrets({"app": [], "staging": [], "rc": []})
          set_block({prod: {"block": false , "reason" : "" , "user": ""}, staging: {"block": false , "reason" : "" , "user": ""}, rc: {"block": false , "reason" : "" , "user": ""}})
        }
        else{
          set_options(['prod', 'staging'])
          setEnv('prod')
          set_secrets({"prod": [], "staging": [], "rc": []})
          set_block({prod: {"block": false , "reason" : "" , "user": ""}, staging: {"block": false , "reason" : "" , "user": ""}, rc: {"block": false , "reason" : "" , "user": ""}})
        }
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code"),
          "service_name" : service_name
        })
        };
        fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/services_details/" , options).then(response=>response.json())
        .then(async data=>{ 
        try{
            data.cronjobs = JSON.parse(data.cronjobs)
            set_service(data)
            set_block({prod: {"block": data.prod_block , "reason" : data.prod_block_reason , "user": data.prod_block_user_name}, staging: {"block": data.staging_block , "reason" : data.staging_block_reason , "user": data.staging_block_user_name}, rc: {"block": data.rc_block , "reason" : data.rc_block_reason , "user": data.rc_block_user_name}})
            if(data.rc_enable && service_name!= 'backend'){
              set_options(['prod', 'staging','rc'])
            }
            var options = {
                'method': 'POST',
                'headers': {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                "code": cookies.get("code"),
                "repo" : data.repository,
                "path": data.path+"README.md"
              })
              };
            fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_file/" , options).then(response=>response.json())
              .then(async data=>{ 
                set_readme(data)
                  if(data==" "){
                    // set_readme("No README file found")
                    set_readme(null)
                  }
                  
              })
        }
        catch (error){
            console.log('error logged', error);
        }
        });

    },[])

    useEffect( () => {
      const queryParams = new URLSearchParams(window.location.search)
      const service_name = queryParams.get("service")
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "service_name" : service_name
      })
  };
  fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/deployments_details/" , options).then(response=>response.json())
  .then(async data=>{ 
    try{
      set_deployments(data.filter(deployment => deployment.env == 'prod'))
      set_all_deployments(data)
    }
    catch (error){
    }

   });

   
  },[])

  useEffect( () => {
    const queryParams = new URLSearchParams(window.location.search)
    const service_name = queryParams.get("service")
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": cookies.get("code"),
      "service_name" : service_name
    })
    };
    if(service_name!='backend'){
     
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_secrets/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_secrets(data)
        }
        catch (error){
        }

      });
    }
    else{
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/get_backend_envs/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_secrets(data)
        }
        catch (error){
        }
  
      });
    }
  
  },[])

    function block_deployment(){
      let new_block = JSON.parse(JSON.stringify(block))
      new_block[env] = {"block": !block[env].block , "reason" : reason , "user": cookies.get("name")}
      set_block(new_block)
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "service_name" : service.service_name,
        "env" : env ,
        "reason" : reason
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/block_deployment/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        }
        catch(error) {
          console.log(error)
        }
      });
      set_open_lock_dialog(false)
      set_open_unlock_dialog(false)
      set_reason("")
    }
  
    function update_secret(){
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "google_code": cookies.get("google_code"),
        "service_name" : service.service_name,
        "env" : env ,
        "key" : secret_key ,
        "value" : secret_value , 
        "code": cookies.get("code")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/google/update_service_secret/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        }
        catch(error) {
          console.log(error)
        }
      });
      let new_secrets = secrets;
      if(open_create_new_service_secret){
        new_secrets[env] =[...new_secrets[env] , {key:secret_key , value:"*****"}]
      }
      set_secrets(new_secrets)
      handle_close_modal();
      set_secret_value("")

    }
  
    const columns = [
      {field:"user" , headerName: "User" , width:200} , 
      {field: "branch" , headerName: "Branch" , width:200} , 
      {field: "date" , headerName: "Date" , width:200 , renderCell: (params) => {return Moment(params.row.date).format('LLL')}} ,
      {field: "github_sha" , headerName: "GitHub sha" , width:200} ,
      {field: "details" , headerName: "Details" , width:200} ,
    ]


    const handleChangeIndex = (index) => {
      setValue(index);
    };

    function QuickSearchToolbar() {
      return (
          <GridToolbarQuickFilter />
      );
    }
    function update_filter(cellData,param){
      if(filterModel.items[0]?.value==cellData.row[param]){
        setFilterModel({
          items: [
            {
              columnField: param,
              operatorValue: 'contains',
              value: ""
            },
          ],
        })
      }
      else{
        setFilterModel({
          items: [
            {
              columnField: param,
              operatorValue: 'contains',
              value: cellData.row[param]
            },
          ],
        })
      }
    }
    const envs_columns = [
      { field: 'key', headerName: 'Key', width: 500},
      { field: 'value', headerName: 'value', width: 300 } ,
      {
        field: "edit",
        headerName: "Edit",
        filterable: false,
        sortable: false,
        width: 200,
        renderCell: (params) => {
          return (
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
            >
              <ModeEditOutlineOutlinedIcon index={params.row.id} />
            </div>
          );
        }
      },
    ]
    return (
        <div className="split right">
        {service && 
        <div className="service">
          <div className="service_top">
       
          <div className="title">
          <a className="block_icon">{ block?.[env]?.["block"] ?(<Tooltip title={`Service deployment blocked in ${env}. Click to unblock it.`} followCursor><LockIcon onClick={() =>handleClickOpen_unlock()}/></Tooltip>): (<Tooltip title={`Service deployment unblocked in ${env}. Click to block it.`} followCursor><LockOpenIcon onClick={() =>handleClickOpen()}/></Tooltip>) } </a>
        <a className="service_name"> {service.service_name} </a>
       
        </div >
        <div className="service_links">
        <div>
          {icon_map.map((element )=> (
            <Tooltip title={element.description} followCursor>
              <Link to={{pathname:element.link}} target="_blank"><img src={element.icon} className="icon"/></Link>
            </Tooltip>
          ))}
          {block?.[env]?.["block"] && <div className="lock_details"><div>blocked by {block[env]["user"]}</div><div>block reason - {block[env]["reason"]}</div></div>}
          </div>
      <Modal open={open_lock_dialog} onClose={()=>handle_close_modal} 
          title={`Lock deployment to `+env}
          text={"To lock deployments to "+env+", please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"Lock" ,  "class": "modalOK" , "onClick" : ()=>block_deployment() ,"disabled": !reason.length}
                  ]}
        />

      <Modal open={open_unlock_dialog} onClose={()=>handle_close_modal} 
          title={`Unlock deployment to `+env}
          text={"To unlock deployments to "+env+", please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" , "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"Unlock" ,  "class": "modalOK" , "onClick" : ()=>block_deployment() ,"disabled": !reason.length }
                  ]}
        />

        <Modal open={open_edit_modal} onClose={()=>handle_close_modal} 
          title={"Edit secret"}
          text={"to edit the secret, please write the new value"}
          textField={true}
          textFieldLabel={"value"}
          textFieldSetText={set_secret_value}
          buttons={[
                    {"text":"Cancel" ,  "class":"modalCancel", "onClick" : ()=>handle_close_modal() },
                    {"text":"Update" , "class": "modalOK" , "onClick" : ()=>update_secret() ,"disabled": !secret_value?.length || !functions.valid(secret_value) }
                  ]}
        />

        <Modal open={open_create_new_service_secret} onClose={()=>handle_close_modal} 
          title={"New service secret"}
          text={"to edit the secret, please write the new value"}
          textField={true}
          textFieldLabel={"key"}
          textFieldSetText={set_secret_key}
          textField2={true}
          textFieldLabel2={"value"}
          textFieldSetText2={set_secret_value}
          buttons={[
                    {"text":"Cancel" , "class":"modalCancel" , "onClick" : ()=>handle_close_modal() },
                    {"text":"Create" ,  "class": "modalOK", "onClick" : ()=>update_secret() ,"disabled": !secret_key?.length || !secret_value?.length || !functions.valid(secret_value) || !functions.valid(secret_key) }
                  ]}
        /> 

        </div>
        <a style={{"text-align": "-webkit-right"}}>{ env && <Autocomplete
        size="small"
        value={env}
        onChange={(event, newValue) => {
          set_deployments(all_deployments.filter(deployment => deployment.env == newValue))
          setEnv(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        id="controllable-states-demo"
        options={options}
        sx={{ width: 350 }}
        renderInput={(params) => <TextField {...params} label="environment" />}
        />}
      </a>
        </div>
      <Box className="test1" sx={{ bgcolor: "background.paper", "height": "-webkit-fill-available" , "margin-bottom": "4em"}}>
        <AppBar className="test2" position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            sx={{width: "min-content"}}
          >
            <Tab label="README" {...a11yProps(0)} />
            <Tab label="Details" {...a11yProps(1)} />
            <Tab label="Deployments" {...a11yProps(1)} />
            <Tab label="Secrets" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
          style={{"background-color": "#F3F6F7" , "padding": "16px" , "margin-top": "1em" , "border": "1px solid #F3F6F7" , "border-radius": "12px"}}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
              <div className="readme">
                {readme ?
                ( <Markdown>{readme}</Markdown> ):
                (<div>No README file found</div>)}
              </div>
            
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction} className="service_details">
            {service.use_yarn ?
              ( <div><GppBadIcon sx={{color: "#F45E44"}}/>Use yarn package manager, please change to npm</div>):
              (<div><GppGoodIcon sx={{color: "#3ACF7D"}}/>Use npm package manager</div>)}
            {service.use_workiz_base_img ?
            (<div><GppGoodIcon sx={{color: "#3ACF7D"}}/>Use workiz base image</div>):
            ( <div><GppBadIcon sx={{color: "#F45E44"}}/>Not using workiz docker base image, please change it or talk to infra team</div>)}
            {service.node_version ?
            (<div><GppGoodIcon sx={{color: "#3ACF7D"}}/>Has a Node.js version declared at .nvmrc file</div>):
            ( <div><GppBadIcon sx={{color: "#F45E44"}}/>Has no .nvmrc file, please add one</div>)}
            {readme? 
            (<div><GppGoodIcon sx={{color: "#3ACF7D"}}/>Has README.md file</div>):
            ( <div><GppBadIcon sx={{color: "#F45E44"}}/>README.md file is not exists, please add one</div>)}
            <GppGoodIcon sx={{color: "#3ACF7D"}}/>cronjobs: 
            {service.cronjobs?.map((cronjob) => (
              <li style={{"marginLeft" : "2em"}}>{cronjob}</li>
            ))}

          </TabPanel>
          
          <TabPanel value={value} index={2} dir={theme.direction} className="service_details">
          <div style={{ backgroundColor: "white" , height: "40em" , cursor: "pointer" }} >
            {deployments && <DataGrid
              filterModel={filterModel}
              onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
              rows={deployments}
              columns={columns}
              pageSize={50}
              sx={{
                boxShadow: 2,
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rowsPerPageOptions={[50]}
              components={{ Toolbar: QuickSearchToolbar }}
              disableSelectionOnClick={true}
              onCellClick={(cellData) => {
                update_filter(cellData,cellData.field)
            }}
            />
            }
            </div>
            
          </TabPanel>
          {service.service_name !='backend' &&  secrets ? (
            <TabPanel value={value} index={3} dir={theme.direction} className="service_details">
              <div style={{"marginBottom" : "0.5em"}}>
                <Chip icon={<AddIcon fontSize="large"/>} label="Add new" style={{"cursor" : "pointer"}} onClick={()=>set_open_create_new_service_secret(true)}/>
                {env=="prod"? (
                  <Chip icon={<KeyIcon fontSize="large"/>} label="Link" style={{"cursor" : "pointer" , "float": "right"}} onClick={()=>window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-${service.service_name}/versions?project=${process.env.REACT_APP_GCP_PROD_SECRET_PROJECT}`, '_blank', 'noreferrer')}/>
                ):(
                  <Chip icon={<KeyIcon fontSize="large"/>} label="Link" style={{"cursor" : "pointer" , "float": "right"}} onClick={()=>window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-${service.service_name}/versions?project=${process.env.REACT_APP_GCP_STAGING_SECRET_PROJECT}`, '_blank', 'noreferrer')}/>
                )}
              </div>
            <div style={{ backgroundColor: "white" , height: "40em" , cursor: "pointer" }} >
              <DataGrid
                rows={secrets?.[env?.toLocaleLowerCase()]}
                columns={envs_columns}
                getRowId={(row) => row.key}
                filterModel={filterModel}
                onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                pageSize={100}
                rowsPerPageOptions={[100]}
                sx={{
                  boxShadow: 2,
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                components={{ Toolbar: QuickSearchToolbar }}
                disableSelectionOnClick={true}
                onCellClick={(cellData) => {
                  if(cellData.field=="google_link"){
                    if(env=="prod"){
                      window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-${service.service_name}/versions?project=${process.env.REACT_APP_GCP_PROD_SECRET_PROJECT}`, '_blank', 'noreferrer')
                    }
                    else{
                      window.open(`https://console.cloud.google.com/security/secret-manager/secret/${env}-${service.service_name}/versions?project=${process.env.REACT_APP_GCP_STAGING_SECRET_PROJECT}`, '_blank', 'noreferrer')
                    }
                  }
                  else if(cellData.field=="edit"){
                    set_open_edit_modal(true)
                    set_secret_key(cellData.row.key)
                  }
                  else {
                    update_filter(cellData,cellData.field)
                  }
              }}
              />
            </div>
          </TabPanel>
          ) : (
            <BackendSecrets env={env} secrets={secrets[env.toLocaleLowerCase()]}/>
          )
          }
        </SwipeableViews>
      </Box>
      </div>
      }
      </div>
    );
  }